<template>
  <th scope="col" class="p-4 text-xs text-gray-500">
    <slot></slot>
  </th>
</template>
